import { SettingsPage } from ".";
import { MenuNode, MenuRoute } from "../../components/menu";
import { LeafRole, Or } from "../../utils/and-or-tree";
import { ShellRouteNames } from "../shell/route-names";

const names = {
  settings: `${ShellRouteNames.shell}.settings`,
};

const states: MenuRoute[] = [
  {
    name: names.settings,
    component: SettingsPage,
    url: "/settings",
    data: {
      title: "settings",
    },
  },
];

const sidebar: MenuNode.MenuNode = {
  icon: "cog",
  route: states[0],
  roles: new Or(
    new LeafRole("ROLE_USER"),
    new LeafRole("ROLE_MERCHANT"),
    new LeafRole("ROLE_ADMIN")
  ),
};

export const SettingsRoutes = {
  names,
  states,
  sidebar,
};
